import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Flex, Box } from '@rebass/grid';

import FloatingLabelInput from 'app/ui_components/FloatingLabelInput';
import { onInputChange } from 'app/redux/actions';

// For restaurant report and when an US_food usertype is employee
class RestaurantReportUnlockForm extends React.Component {
  static propTypes = {
    handleChange: PropTypes.func,
    name: PropTypes.string,
    email: PropTypes.string,
    restaurantName: PropTypes.string
  };

  static defaultProps = {
    usFoods: false,
    name: '',
    email: '',
    restaurantName: '',
    zipCode: ''
  };

  render() {
    const { handleChange, name, email, restaurantName } = this.props;
    return (
      <React.Fragment>
        <Flex flexDirection="row" justifyContent="center" flexWrap="wrap">
          <Box width={[1, 1 / 2, 1 / 2]} px={10} pb={[16, 20, 4]}>
            <FloatingLabelInput
              border
              type="text"
              placeholder="Your Name*"
              name="name"
              value={name}
              handleChange={handleChange}
              aria-label="Your name"
              label="Your Full Name"
              autoFocus
            />
          </Box>
          <Box width={[1, 1 / 2, 1 / 2]} px={10} pb={[16, 20, 4]}>
            <FloatingLabelInput
              border
              type="text"
              placeholder="Restaurant Name*"
              name="restaurantName"
              value={restaurantName}
              handleChange={handleChange}
              aria-label="Restaurant Name"
              label="Restaurant Name"
            />
          </Box>
        </Flex>
        <Flex flexDirection="row" justifyContent="center" flexWrap="wrap">
          <Box width={1} pb={[16, 20, 4]} px={10}>
            <FloatingLabelInput
              border
              type="email"
              placeholder="Your Email*"
              name="email"
              value={email}
              handleChange={handleChange}
              aria-label="Your email"
              label="Your Email"
            />
          </Box>
        </Flex>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  usFoods,
  user: {
    name,
    email,
    restaurantName
  }
}) => ({
  usFoods,
  name,
  email,
  restaurantName
});

const mapDispatchToProps = dispatch => ({
  handleChange: e => dispatch(onInputChange('user', e.target.name, e.target.value))
});

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantReportUnlockForm);